import { UBTUtils } from '@/utils/ubt';
import { getSystemCode } from '@/utils/systemCode';

const SPM = {
  // 页面曝光
  pageView: {
    platform_tt_huandian() {
      const payParams = this.payParams || {};
      const goods = this.goods || {};
      UBTUtils.pageView({
        categoryId: 'platform',
        pageId: 'platform_tt_huandian',
        businessParam: {
          productTagForDySign: payParams.productTagForDySign || '',
          adsource: this.adsource,
          systemcode: getSystemCode(),
          spuId: goods.spuId || '',
          abVersion: '',
        },
      });
    },
    platform_tt_huandian_finish() {
      const payParams = this.payParams || {};
      const goods = this.goods || {};
      UBTUtils.pageView({
        categoryId: 'platform',
        pageId: 'platform_tt_huandian_finish',
        businessParam: {
          abVersion: '',
          productTagForDySign: payParams.productTagForDySign || '',
          spuId: goods.spuId || '',
          systemcode: getSystemCode(),
          adsource: this.adsource,
        },
      });
    },
  },
  // 页面离开
  pageViewOut: {
    platform_tt_huandian() {
      const payParams = this.payParams || {};
      const goods = this.goods || {};
      UBTUtils.pageViewOut({
        categoryId: 'platform',
        pageId: 'platform_tt_huandian',
        businessParam: {
          productTagForDySign: payParams.productTagForDySign || '',
          adsource: this.adsource,
          systemcode: getSystemCode(),
          spuId: goods.spuId || '',
          abVersion: '',
        },
      });
    },
    platform_tt_huandian_finish() {
      const payParams = this.payParams || {};
      const goods = this.goods || {};
      UBTUtils.pageViewOut({
        categoryId: 'platform',
        pageId: 'platform_tt_huandian_finish',
        businessParam: {
          abVersion: '',
          productTagForDySign: payParams.productTagForDySign || '',
          spuId: goods.spuId || '',
          systemcode: getSystemCode(),
          adsource: this.adsource,
        },
      });
    },
  },
  // 按钮点击
  clickButton: {
    platform_tt_huandian_buttun() {
      const payParams = this.payParams || {};
      const goods = this.goods || {};
      UBTUtils.clickButton({
        categoryId: 'platform',
        pageId: 'platform_tt_huandian',
        buttonName: 'platform_tt_huandian_buttun',
        businessParam: {
          productTagForDySign: payParams.productTagForDySign || '',
          adsource: this.adsource,
          systemcode: getSystemCode(),
          spuId: goods.spuId || '',
          abVersion: '',
        },
      });
    },
    platform_tt_huandian_finish_buttun() {
      const payParams = this.payParams || {};
      const goods = this.goods || {};
      UBTUtils.clickButton({
        categoryId: 'platform',
        pageId: 'platform_tt_huandian_finish',
        buttonName: 'platform_tt_huandian_finish_buttun',
        businessParam: {
          adsource: this.adsource,
          systemcode: getSystemCode(),
          spuId: goods.spuId || '',
          productTagForDySign: payParams.productTagForDySign || '',
          abVersion: '',
        },
      });
    },
  },
  // 模块曝光
  moduleExpose: {
    platform_tt_huandian_buttun() {
      const payParams = this.payParams || {};
      const goods = this.goods || {};
      UBTUtils.moduleExpose({
        categoryId: 'platform',
        pageId: 'platform_tt_huandian',
        moduleId: 'platform_tt_huandian_buttun',
        contentId: 'platform_tt_huandian_buttun',
        exposureTimes: 1,
        businessParam: {
          productTagForDySign: payParams.productTagForDySign || '',
          adsource: this.adsource,
          systemcode: getSystemCode(),
          spuId: goods.spuId || '',
          abVersion: '',
        },
      });
    },
    platform_tt_huandian_empty() {
      const payParams = this.payParams || {};
      const goods = this.goods || {};
      UBTUtils.moduleExpose({
        categoryId: 'platform',
        pageId: 'platform_tt_huandian',
        moduleId: 'platform_tt_huandian_empty',
        contentId: 'platform_tt_huandian_empty',
        exposureTimes: 1,
        businessParam: {
          abVersion: '',
          spuId: goods.spuId || '',
          systemcode: getSystemCode(),
          adsource: this.adsource,
          productTagForDySign: payParams.productTagForDySign || '',
        },
      });
    },
    platform_tt_huandian_finish_buttun() {
      const payParams = this.payParams || {};
      const goods = this.goods || {};
      UBTUtils.moduleExpose({
        categoryId: 'platform',
        pageId: 'platform_tt_huandian_finish',
        moduleId: 'platform_tt_huandian_finish_buttun',
        contentId: 'platform_tt_huandian_finish_buttun',
        exposureTimes: 1,
        businessParam: {
          adsource: this.adsource,
          systemcode: getSystemCode(),
          spuId: goods.spuId || '',
          productTagForDySign: payParams.productTagForDySign || '',
          abVersion: '',
        },
      });
    },
  },
};

export default SPM;
